export default "https://cdn-static.gokick.com/assets/d05c895b658955f243e3d6e9c630166e56cf3faa/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";